import styled from '@emotion/styled';
import classnames from 'classnames';
import type { JSX } from 'react';
import {
  IconCaretDown,
  IconCaretUp,
  IconSquareCaretDown,
  IconSquareCaretUp,
} from 'src/components/BasicComponents/Icons';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import type { SortKey } from './types';

export function SortSelect({
  sortKey,
  sortDirection,
  onSort,
}: {
  sortKey: SortKey;
  sortDirection: 'ASC' | 'DESC' | null;
  onSort: (key: 'ASC' | 'DESC' | null) => void;
}): JSX.Element {
  return (
    <SortSelectWrapper>
      <div className="sort-select-key">{t(`sort.${sortKey}`)}</div>
      <div className="sort-select-values">
        <div
          className={classnames('sort-select-value', { active: sortDirection === 'DESC' })}
          {...onClickGenerator(() => onSort(sortDirection === 'DESC' ? null : 'DESC'))}
        >
          {sortDirection === 'DESC' ? <IconSquareCaretDown /> : <IconCaretDown />}
        </div>
        <div
          className={classnames('sort-select-value', { active: sortDirection === 'ASC' })}
          {...onClickGenerator(() => onSort(sortDirection === 'ASC' ? null : 'ASC'))}
        >
          {sortDirection === 'ASC' ? <IconSquareCaretUp /> : <IconCaretUp />}
        </div>
      </div>
    </SortSelectWrapper>
  );
}

const SortSelectWrapper = styled.div`
  display: flex;
  padding: 5px 10px;
  align-items: start;

  .sort-select-key {
    line-height: 30px;
    font-weight: 600;
    flex: 1;
  }

  .sort-select-values {
    display: flex;
    flex-direction: row;
    margin-left: 5px;
    min-height: 30px;

    .sort-select-value {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      font-size: 20px;
      cursor: pointer;
      color: #888888;

      &.active {
        color: var(--base-color);
      }
    }
  }
`;
